// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carditem-row[data-v-3d13fab2] {\n  line-height: 40px;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n}", ""]);
// Exports
module.exports = exports;
